'use client';

import { ResultCard } from '@pickleballinc/react-ui';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';

import { MatchExtended, MatchInfo } from '@/modules/ticker/types';
import { formatMatchInfo } from '@/utils/helpers/formatMatchInfo';

export interface RenderMatchesProps {
  initialMatches: MatchInfo[];
}

export const RenderResultCard = ({
  initialMatches,
  rounded,
}: RenderMatchesProps & { rounded?: boolean }) => {
  if (initialMatches.length === 0) return null;

  const duoMatch = initialMatches && initialMatches[0] && initialMatches[0].teamOnePlayerTwoUuid;

  const formattedResults: MatchExtended[] = formatMatchInfo({
    matchInfos: initialMatches,
    imagesWidth: duoMatch ? 22 : 38,
    imagesHeight: duoMatch ? 22 : 38,
    matchCardType: 'RESULT',
  });

  return (
    <div className='-mx-4 flex w-[calc(100%+32px)] flex-col gap-4 rounded-lg sm:-mx-6 sm:w-[640px]'>
      {formattedResults.map((result) => (
        <CustomLink
          key={result.id}
          className='cursor-pointer hover:opacity-80'
          href={`/results/match/${result.id}`}
        >
          <ResultCard match={result} rounded={rounded} />
        </CustomLink>
      ))}
    </div>
  );
};
